import { Routes } from '@angular/router';
import { MainLayoutComponent } from './core/layouts/main-layout/main-layout.component';
import { confirmExitGuard } from './core/guards/confirm-exit/confirm-exit.guard';
import { ModuleLayoutComponent } from './core/layouts/module-layout/module-layout.component';
import { MsalGuard } from '@azure/msal-angular';
import { LogoutComponent } from './feature/logout/logout.component';
import { environment } from '../environments/environment';
import { authorisedGuard } from './core/guards/authorised/authorised.guard';

export const routes: Routes = [
    {
        path: 'logout',
        component: LogoutComponent,
    },
    {
        path: 'unauthorised',
        title: 'Unauthorised | SSBA',
        loadComponent: () =>
            import('./feature/unauthorised/unauthorised.component').then(component => component.UnauthorisedComponent),
    },
    {
        path: '',
        component: MainLayoutComponent,
        canActivate: environment.useMockAuth ? [authorisedGuard] : [MsalGuard, authorisedGuard],
        children: [
            {
                path: '',
                title: 'Home | SSBA',
                loadComponent: () =>
                    import('./feature/home/page/home.component').then(component => component.HomeComponent),
            },
            {
                path: 'perform-module',
                title: 'Perform Module | SSBA',
                loadComponent: () =>
                    import('./feature/modules-list/page/modules-list.component').then(
                        component => component.ModulesListComponent,
                    ),
            },
            {
                path: 'resources',
                title: 'Resources | SSBA',
                loadComponent: () =>
                    import('./feature/resources/page/resources.component').then(
                        component => component.ResourcesComponent,
                    ),
            },
        ],
    },
    {
        path: 'module',
        component: ModuleLayoutComponent,
        canActivate: environment.useMockAuth ? [] : [MsalGuard],
        children: [
            {
                path: 'slides/:module',
                title: 'Module | SSBA',
                loadComponent: () =>
                    import('./feature/module/page/module.component').then(component => component.ModuleComponent),
                canDeactivate: [confirmExitGuard],
            },
            {
                path: 'quiz/:module',
                title: 'Quiz | SSBA',
                loadComponent: () =>
                    import('./feature/quiz/page/quiz.component').then(component => component.QuizComponent),
                canDeactivate: [confirmExitGuard],
            },
            {
                path: 'quiz-results/:module',
                title: 'Quiz Results | SSBA',
                loadComponent: () =>
                    import('./feature/quiz-results/page/quiz-results.component').then(
                        component => component.QuizResultsComponent,
                    ),
                canDeactivate: [confirmExitGuard],
            },
            {
                path: 'feedback/:module',
                title: 'Module Feedback | SSBA',
                loadComponent: () =>
                    import('./feature/feedback/page/feedback.component').then(component => component.FeedbackComponent),
                canDeactivate: [confirmExitGuard],
            },
            {
                path: 'submission-failed',
                title: 'Submission Failed | SSBA',
                loadComponent: () =>
                    import('./feature/submission-failed/submission-failed.component').then(
                        component => component.SubmissionFailedComponent,
                    ),
            },
        ],
    },
    {
        path: '**',
        title: 'Not Found | SSBA',
        loadComponent: () =>
            import('./feature/not-found/page/not-found.component').then(component => component.NotFoundComponent),
        canActivate: [MsalGuard],
    },
];
